import { Component, OnInit, ViewChild } from '@angular/core';
import { EntidadService } from 'src/app/services/entidad/entidad.service';
import { FichaXInstancia } from 'src/app/models/FichaXInstancia';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalInstanciaComponent } from './modal-instancia/modal-instancia.component';
import { iconEliminar, iconAgregar, iconEditar, DscTituloPaginator, isEmptyList, openModalMensajePrg, strDscMsjPrgEliminar, recupDscTipoInstancia, strMatTablePaginator, modificarTamañoModal } from 'src/app/general/variables';
import { Fur } from 'src/app/models/Fur';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-instancia',
  templateUrl: './instancia.component.html',
  styleUrls: ['./instancia.component.css']
})
export class InstanciaComponent implements OnInit {

  dataSource: MatTableDataSource<FichaXInstancia>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  matTableColumnsDef = ['item', 'TipoEntidad', 'Entidad', 'NúmeroDoc', 'Fecha', 'Estado', 'EditarInst', 'Eliminar'];
  matTableColumnsEtiq = ['Ítem', 'Tipo Entidad', 'Entidad', 'Número de documento', 'Fecha', 'Estado', 'Editar', 'Eliminar'];
  strMatTablePaginator = strMatTablePaginator;

  instanciaList: FichaXInstancia[] = [];
  otra_instancia = false;
  iconAgregar = iconAgregar;
  iconoEliminar = iconEliminar;
  iconoEditar = iconEditar;
  flgLectura = false;
  strDscTitulo = 'Otra(s) Entidad(es)';
  recupDscTipoInstancia = recupDscTipoInstancia;
  constructor(private entidadService: EntidadService,
              public dialog: MatDialog,
              private spinner: NgxSpinnerService) { }

  ngOnInit() {



  }

  getFlgOtraInstancia() {

    return this.otra_instancia;


  }

  _cambioOtraInstancia(valor) {
    this.otra_instancia = valor;
  }

  abrirModalInstancia(instanciaList: FichaXInstancia[] , instanciaModificar: FichaXInstancia, modificar: boolean) {
    this.abrirModal(instanciaList, instanciaModificar , modificar, 0);
  }

  abrirModal( instanciaList: FichaXInstancia[] , instanciaModificar: FichaXInstancia, modificar: boolean, index: number) {

    let configuracionGlobal = new MatDialogConfig();
    const vListaInstancia = JSON.parse( JSON.stringify( instanciaList ) );
    const vInstanciaModificar = JSON.parse( JSON.stringify( instanciaModificar ) );

    configuracionGlobal.disableClose = true;
    configuracionGlobal.autoFocus = true;
    configuracionGlobal.data = {
      // listaInstancia: instanciaList,
      listaInstancia: vListaInstancia,
      instancia : vInstanciaModificar,
      modificar,
      indexModif: index
    };

    configuracionGlobal = modificarTamañoModal(configuracionGlobal);

    // configuracionGlobal.width = "80%";
    // configuracionGlobal.maxHeight = 600;

    const  modal = this.dialog.open(ModalInstanciaComponent, configuracionGlobal);

    modal.afterClosed().subscribe( data => {

          // console.log("=======dataReturn");
          // console.log(data);

           if (data != null) {

            this.instanciaList = vListaInstancia;

            this._cargarTableMaterial();

           }

         }

      );
  }

  _eliminar(instancia) {

    openModalMensajePrg(this.strDscTitulo, strDscMsjPrgEliminar, this.dialog).subscribe(result => {

      // if(result != true)
      if (result == false) {

        this.instanciaList.splice(this.instanciaList.indexOf(instancia), 1);
        this._cargarTableMaterial();


      }

    });


  }

  editar(instanciaList: FichaXInstancia[] , instanciaModificar: FichaXInstancia, modificar: boolean, index: number) {
    this.abrirModal(instanciaList, instanciaModificar, modificar, index);
  }

  setInstanciaC(fur: Fur) {

    const vListaInst = fur.listaFichaPorInstancia;
    const vFlgEmptyList = isEmptyList(vListaInst);

    this.instanciaList = vListaInst;

    this._cambioOtraInstancia(!vFlgEmptyList);

    // if(vListaInst != null)
    // {

    // }

    if (!vFlgEmptyList) {

      this._cargarTableMaterial();

    }

  }

  instanciaCReadEnable() {
    // console.log("===================this.flgLectura");
    // console.log(this.flgLectura);
    this.flgLectura = true;
  }

  instanciaCReadDisable() {
    this.flgLectura = false;
  }

  _cargarTableMaterial() {


    setTimeout(() => {

      // console.log("=====================this.instanciaList");
      // console.log(this.instanciaList);

      this.dataSource = new MatTableDataSource(this.instanciaList);

      if (this.paginator != null) {this.paginator._intl.itemsPerPageLabel = DscTituloPaginator; } // this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;

      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

      // console.log("=====================this.instanciaListFINNNNNNNNNNNNNNNN");

    }, 1);


  }
}
